import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/** @jsx jsx */

import { PureComponent } from 'react';
import { css, jsx } from '@emotion/react';
import { themed } from '@atlaskit/theme/components';
import { DN50, N100, N20A } from '@atlaskit/theme/colors';
import { borderRadius, gridSize } from '@atlaskit/theme/constants';
var contentStyle = css({
  margin: 0,
  wordWrap: 'break-word',
  minWidth: 0,
  flex: '1 1 auto'
});
var taskStyles = css({
  display: 'flex',
  flexDirection: 'row',
  padding: '6px 3px',
  position: 'relative'
});
var decisionStyles = function decisionStyles(theme) {
  return css({
    display: 'flex',
    flexDirection: 'row',
    margin: "".concat(gridSize(), "px 0 0 0"),
    padding: "".concat(gridSize(), "px"),
    paddingLeft: "".concat(gridSize() * 1.5, "px"),
    borderRadius: "".concat(borderRadius(), "px"),
    backgroundColor: themed({
      light: "var(--ds-background-neutral, ".concat(N20A, ")"),
      dark: "var(--ds-background-neutral, ".concat(DN50, ")")
    })({
      theme: theme
    }),
    position: 'relative',
    '.decision-item': {
      cursor: 'initial'
    }
  });
};
var placeHolderStyles = function placeHolderStyles(offset) {
  return css({
    margin: "0 0 0 ".concat(offset, "px"),
    position: 'absolute',
    color: "var(--ds-text-subtlest, ".concat(N100, ")"),
    pointerEvents: 'none',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: 'calc(100% - 50px)'
  });
};
var Item = /*#__PURE__*/function (_PureComponent) {
  _inherits(Item, _PureComponent);
  var _super = _createSuper(Item);
  function Item() {
    _classCallCheck(this, Item);
    return _super.apply(this, arguments);
  }
  _createClass(Item, [{
    key: "renderPlaceholder",
    value: function renderPlaceholder() {
      var _this$props = this.props,
        children = _this$props.children,
        placeholder = _this$props.placeholder,
        showPlaceholder = _this$props.showPlaceholder,
        itemType = _this$props.itemType;
      if (!showPlaceholder || !placeholder || children) {
        return null;
      }
      var offset = gridSize() * (itemType === 'TASK' ? 3 : 3.5);
      return jsx("span", {
        "data-component": "placeholder",
        css: placeHolderStyles(offset),
        contentEditable: false
      }, placeholder);
    }
  }, {
    key: "renderMessageAppearance",
    value: function renderMessageAppearance() {
      var _this$props2 = this.props,
        contentRef = _this$props2.contentRef,
        children = _this$props2.children,
        icon = _this$props2.icon,
        itemType = _this$props2.itemType,
        checkBoxId = _this$props2.checkBoxId,
        dataAttributes = _this$props2.dataAttributes,
        theme = _this$props2.theme;
      if (itemType === 'TASK') {
        return jsx("div", {
          css: taskStyles,
          id: "".concat(checkBoxId, "-wrapper")
        }, icon, this.renderPlaceholder(), jsx("div", _extends({
          "data-component": "content",
          css: contentStyle,
          ref: contentRef
        }, dataAttributes), children));
      } else if (itemType === 'DECISION') {
        return jsx("div", {
          css: decisionStyles(theme),
          "data-decision-wrapper": "true"
        }, icon, this.renderPlaceholder(), jsx("div", _extends({
          "data-component": "content",
          css: contentStyle,
          ref: contentRef
        }, dataAttributes), children));
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderMessageAppearance();
    }
  }]);
  return Item;
}(PureComponent);
_defineProperty(Item, "defaultProps", {
  appearance: 'inline'
});
export { Item as default };